import { useEffect, useState } from 'react'

import { errorMessage } from '@/shared/api/httpClient'

/**
 * Carrega dados com useEffect + useState. `setData` serve para refletir
 * mutações (PATCH/DELETE) no que já está na tela sem recarregar.
 */
export function useAsync<T>(load: () => Promise<T>, deps: readonly unknown[] = []) {
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let alive = true
    setLoading(true)
    setError(null)
    load().then(
      (result) => {
        if (!alive) return
        setData(result)
        setLoading(false)
      },
      (err: unknown) => {
        if (!alive) return
        setError(errorMessage(err))
        setLoading(false)
      },
    )
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return { data, setData, error, loading }
}
